module.exports = __webpack_public_path__ + "img/achievement.55f431eb.png";